import { ReactNode } from 'react';
import { Text } from '@msc-b2c/shared-components';

import styles from '../customerinformationcontainer.module.scss';

export function CustomerInformationSectionInfo({
  infoLabel,
  infoValue,
}: Readonly<{
  infoLabel: string;
  infoValue?: string;
}>): ReactNode {
  return (
    <div className={styles['cmp-customer-information-container__section-info']}>
      <Text
        text={`${infoLabel} `}
        styleOption="cmp-text__small bold"
      />
      {infoValue && (
        <Text
          text={infoValue}
          styleOption="cmp-text__normal"
        />
      )}
    </div>
  );
}
